/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ErrorResponse', 'model/GeoResponseLink', 'model/PointElevation'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./ErrorResponse'), require('./GeoResponseLink'), require('./PointElevation'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.PointResponsePointElevation = factory(root.GisServerApis.ApiClient, root.GisServerApis.ErrorResponse, root.GisServerApis.GeoResponseLink, root.GisServerApis.PointElevation);
  }
}(this, function(ApiClient, ErrorResponse, GeoResponseLink, PointElevation) {
  'use strict';




  /**
   * The PointResponsePointElevation model module.
   * @module model/PointResponsePointElevation
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>PointResponsePointElevation</code>.
   * @alias module:model/PointResponsePointElevation
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>PointResponsePointElevation</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PointResponsePointElevation} obj Optional instance to populate.
   * @return {module:model/PointResponsePointElevation} The populated <code>PointResponsePointElevation</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('coord')) {
        obj['coord'] = ApiClient.convertToType(data['coord'], 'String');
      }
      if (data.hasOwnProperty('data')) {
        obj['data'] = PointElevation.constructFromObject(data['data']);
      }
      if (data.hasOwnProperty('link')) {
        obj['link'] = GeoResponseLink.constructFromObject(data['link']);
      }
      if (data.hasOwnProperty('error')) {
        obj['error'] = ErrorResponse.constructFromObject(data['error']);
      }
      if (data.hasOwnProperty('status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'String');
      }
      if (data.hasOwnProperty('elapsedTime')) {
        obj['elapsedTime'] = ApiClient.convertToType(data['elapsedTime'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {String} coord
   */
  exports.prototype['coord'] = undefined;
  /**
   * @member {module:model/PointElevation} data
   */
  exports.prototype['data'] = undefined;
  /**
   * @member {module:model/GeoResponseLink} link
   */
  exports.prototype['link'] = undefined;
  /**
   * @member {module:model/ErrorResponse} error
   */
  exports.prototype['error'] = undefined;
  /**
   * @member {String} status
   */
  exports.prototype['status'] = undefined;
  /**
   * @member {String} elapsedTime
   */
  exports.prototype['elapsedTime'] = undefined;



  return exports;
}));



